import { z } from "zod";

export const SearchHistorySchema = z
  .record(z.string(), z.array(z.string().min(1)).optional().default([]).catch([]))
  .optional()
  .default({})
  .catch({});
